import { useQueryClient, useMutation } from '@tanstack/react-query';
import { googleDriveMutationKeys } from '../../googleDrive/mutations/googleDriveMutationKeys.js';
import { useWoody } from '../../woody/woody.js';
import { useAnalytics } from '../../analytics/hooks/useAnalytics.js';
import { confirm } from '../../store/alerts.js';
import { rootQueryKeys } from '../../resource-roots/queries/rootQueryKeys.js';
import { AnalyticsEvents } from '../../analytics/analytics.types.js';
import { integrationsQueryKeys } from '../queries/integrationsQueryKeys.js';

const useMutationMirrorRegistryDelete = () => {
  const { client } = useWoody();
  const queryClient = useQueryClient();
  const { track } = useAnalytics();
  return useMutation({
    mutationKey: googleDriveMutationKeys.deleteGoogleDriveMirror(),
    mutationFn: async (variables) => {
      const { mirrorRegistry } = variables;
      const confirmed = await confirm({
        title: `Disconnect ${mirrorRegistry.name}?`,
        content: "All data associated to it will be permanently removed from your Fabric.",
        confirmLabel: "Yes, disconnect",
        cancelLabel: "Cancel",
        confirmButtonProps: {
          variant: "danger"
        }
      });
      if (!confirmed) {
        return false;
      }
      return client.v2({
        endpoint: "/v2/mirror-registry/{mirrorRegistryId}",
        params: {
          mirrorRegistryId: mirrorRegistry.id
        }
      }, {
        method: "delete"
      });
    },
    onSuccess: (result, folderId) => {
      if (result) {
        queryClient.invalidateQueries({
          queryKey: rootQueryKeys.resourceRootList()
        });
        queryClient.invalidateQueries({
          queryKey: integrationsQueryKeys.list()
        });
        track(AnalyticsEvents.DeleteConnectionMirror, {
          folderId
        });
      }
    }
  });
};

export { useMutationMirrorRegistryDelete };
//# sourceMappingURL=useMutationMirrorRegistryDelete.js.map
